import { render, staticRenderFns } from "./EditHealthCheck.vue?vue&type=template&id=3ee8f4de"
import script from "./EditHealthCheck.vue?vue&type=script&lang=ts"
export * from "./EditHealthCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports